import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Navbar, Nav } from "react-bootstrap";
import DarkLogo from "../../assets/images/logos/logo.webp";
import Logo from "../../assets/images/logos/white_logo.png";
import PathConstants from "../../routes/pathConstants";
import LanguageSwitcher from "../language-switcher";
import breakpoints from "../../constants/breakpoints";
import { ResourceTypes } from "../../constants/enums";
import CustomBtn from "../common/buttons/CustomBtn";
import { useDonateModal } from "../donate-modal/donate-modal-context";
import { getAccessToken } from "../../services/auth/auth.storage";

const NavBar = ({ absoluteNavbar = true }) => {
  //Hocks
  const { t, i18n } = useTranslation();
  const { openDonateModal } = useDonateModal();
  const isLg = useMediaQuery({ query: `(max-width: ${breakpoints.lg})` });
  const isLargerThanLg = useMediaQuery({
    query: `(min-width: ${breakpoints.lg})`,
  });

  const isAr = i18n.language === "ar";
  const location = useLocation();
  const isHomePage = location.pathname === PathConstants.HOME;
  const isAuthenticated = !!getAccessToken();

  // States
  const [isCollapsed, setIsCollapsed] = useState(false);

  // const staticPages = [
  //   { label: "About Us", path: PathConstants.ABOUT_US },
  //   { label: "Contact Us", path: PathConstants.CONTACT_US },
  //   {
  //     label: "Achievements and Statistics",
  //     path: PathConstants.ACHIEVEMENTS_AND_STATISTICS,
  //   },
  //   {
  //     label: "Naqsh Platform Donation",
  //     path: PathConstants.NAQSH_PLATFORM_DONATION,
  //   },
  //   { label: "Projects", path: PathConstants.PROJECTS },
  //   { label: "Project Details", path: PathConstants.PROJECT_DETAILS },
  //   { label: "Partners", path: PathConstants.PARTNERS },
  //   { label: "Team", path: PathConstants.TEAM },
  //   { label: "Active Campaigns", path: PathConstants.ACTIVE_CAMPAIGNS },
  //   { label: "Campaign Details", path: PathConstants.CAMPAIGN_DETAILS },
  // ];

  const staticPages = [
    { label: "Nav About", path: PathConstants.ABOUT_US },
    { label: "Nav Achievements", path: PathConstants.ACHIEVEMENTS },
    { label: "Nav Campaigns", path: PathConstants.ACTIVE_CAMPAIGNS },
    { label: "Nav Projects", path: PathConstants.PROJECTS },
    { label: "Nav Partnerships", path: PathConstants.PARTNERS_AND_TEAM },
    { label: "Nav Contact", path: PathConstants.CONTACT_US },
  ];
  // Auto-close navbar when screen is larger than xl
  useEffect(() => {
    if (isLargerThanLg) {
      setIsCollapsed(false);
    }
  }, [isLargerThanLg]);

  const renderNavItem = (item, index) => (
    <Nav.Item
      className={`nav-item ${location.pathname === item.path ? "active-link" : ""
        }`}
      key={item.path || index}
    >
      <Nav.Link
        as={Link}
        className={`nav-link underline-item ${location.pathname === item.path ? "active-link" : ""
          }`}
        to={item.path}
      >
        {t(item.label)}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <Styles
      isHomePage={isHomePage}
      isCollapsed={isCollapsed}
      isAr={isAr}
      isOpen={isCollapsed}
      absoluteNavbar={absoluteNavbar}
    >
      <Navbar expand="lg" expanded={isCollapsed}>
        <div className="container">
          <Link className="logo-container" to={PathConstants.HOME}>
            {/* {Logo && ( */}
            <img
              width={"175px"}
              height={"81px"}
              loading="lazy"
              src={absoluteNavbar ? DarkLogo : Logo}
              alt="Logo"
              className="logo"
            />
            {/* )} */}
          </Link>

          <Navbar.Toggle
            aria-controls="navbarScroll"
            onClick={() => setIsCollapsed(!isCollapsed)}
          />

          <Navbar.Collapse id="navbarScroll" className="nav-container">
            <Nav>
              {staticPages.map(renderNavItem)}
              {isLg && (
                <>
                  {/* <NavSearchInput /> */}

                  <div className="controllers">
                    <LanguageSwitcher />
                  </div>
                  <CustomBtn
                    text={t("Donate")}
                    onClick={() => openDonateModal(ResourceTypes.PLATFORM)}
                    color={"var(--main-color)"}
                    textColor={"var(--white)"}
                    borderRadius="100px !important"
                    withoutTranslate={true}
                  />
                  <CustomBtn
                    text={t(isAuthenticated ? "My profile" : "Login")}
                    link={
                      isAuthenticated
                        ? PathConstants.PROFILE
                        : PathConstants.LOGIN
                    }
                    color={"var(--main-color)"}
                    textColor={"var(--white)"}
                    borderRadius="100px !important"
                    withoutTranslate={true}
                  />
                </>
              )}
            </Nav>
          </Navbar.Collapse>

          {!isLg && (
            <div className="controllers">
              {/* <NavSearchInput /> */}
              <LanguageSwitcher />
              <CustomBtn
                text={t("Donate now")}
                onClick={() => openDonateModal(ResourceTypes.PLATFORM)}
                color={"var(--main-color)"}
                textColor={"var(--white)"}
                borderRadius="100px !important"
              />
              <CustomBtn
                text={t(isAuthenticated ? "My profile" : "Login")}
                link={
                  isAuthenticated ? PathConstants.PROFILE : PathConstants.LOGIN
                }
                color={"var(--main-color)"}
                textColor={"var(--white)"}
                borderRadius="100px !important"
                withoutTranslate={true}
              />
            </div>
          )}
        </div>
      </Navbar>
    </Styles>
  );
};

export default NavBar;
